import { useEffect } from "react";

export default function useScrollOverride() {
  useEffect(() => {
    const style = document.createElement("style");

    style.innerHTML = `
      body::-webkit-scrollbar { width: 0px; }
      body::-webkit-scrollbar-thumb { background: gray; }
      body::-webkit-scrollbar-track { background: transparent; }
    `;

    document.head.appendChild(style);

    return () => document.head.removeChild(style);
  }, []);
}
